export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

export const STORAGE_KEY = 'substyle_utm';

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

export function captureUtmsFromUrl(): UtmParams {
  const params = new URLSearchParams(window.location.search);
  const out: UtmParams = {};
  for (const key of UTM_KEYS) {
    const v = params.get(key);
    if (v) out[key] = v;
  }
  return out;
}

export function persistUtms(utms: UtmParams): void {
  if (Object.keys(utms).length) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  }
}

export function getStoredUtms(): UtmParams {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as UtmParams) : {};
  } catch {
    return {};
  }
}

/** Call once on initial load when UTMs may be present on the URL (e.g. marketing landing). */
export function initUtmsFromUrl(): void {
  const fromUrl = captureUtmsFromUrl();
  if (Object.keys(fromUrl).length) persistUtms(fromUrl);
}
